'use client'

const SCRIPT_ID = 'gather-external'

/**
 * Injects the Gather Form script into the document if it isn't already present.
 *
 * This function checks if the Gather Form script (identified by SCRIPT_ID) is already loaded
 * in the document. If not, it creates a new script element, sets its source to the Gather script URL,
 * and appends it asynchronously to the document body.
 */
export const injectGatherFormScript = () => {
  if (typeof document === 'undefined') {
    return
  }

  const isScriptPresent = document.getElementById(SCRIPT_ID)

  if (isScriptPresent) return

  const script = document.createElement('script')

  script.src = 'https://gather.dustin.com/fs/script.js'
  script.async = true
  script.id = SCRIPT_ID

  document.body.appendChild(script)
}
